import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmObjectType } from '../interfaces/IKnmObjectType';

export async function fetchKnmObjectTypes(): Promise<IKnmObjectType[]> {
  return apiGet<IKnmObjectType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-object-types`);
}
